export default {
	'technical-and-financial-offers': 'Technical and financial offers',
	'the-technical-and-financial-offers': 'the technical and financial offer?',
    'technical-and-financial-offer': 'Technical and financial offer',
    'add-a-technical-and-financial-offer': 'add a technical and financial offer'
}